var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconKey = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M43.4773 4.52308C37.4458 -1.50842 27.6323 -1.50833 21.6008 4.52317C17.4809 8.64301 16.0499 14.7144 17.8338 20.2226L0.413008 37.6435C0.149289 37.9072 0.000976562 38.2642 0.000976562 38.6378V46.5933C0.000976562 47.3706 0.629945 47.9995 1.40723 47.9995H9.36267C9.73617 47.9995 10.0933 47.8512 10.3569 47.5875L12.3454 45.5976C12.6489 45.2941 12.7972 44.8684 12.7478 44.4412L12.5006 42.3044L15.4614 42.0256C16.1343 41.9624 16.6658 41.4309 16.729 40.758L17.0078 37.7972L19.1446 38.0457C19.5415 38.0992 19.9411 37.966 20.2419 37.6997C20.5412 37.4319 20.7129 37.0501 20.7129 36.6491V34.0308H23.2837C23.6572 34.0308 24.0143 33.8825 24.2779 33.6188L27.8842 30.0602C33.3911 31.8455 39.3574 30.5223 43.4773 26.3996C49.5088 20.3682 49.5088 10.5546 43.4773 4.52308ZM39.499 14.4671C37.8538 16.1124 35.1786 16.1124 33.5334 14.4671C31.8882 12.8219 31.8882 10.1468 33.5334 8.50154C35.1786 6.85633 37.8538 6.85633 39.499 8.50154C41.1442 10.1468 41.1441 12.8219 39.499 14.4671Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconKey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_key.93a4e03d.svg";
export { ForwardRef as ReactComponent };